import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shenhe",
  "use": "icon-shenhe-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shenhe\"><path d=\"M808.28 605.63H650.91c-26.16 0-52.84-31.32-52.84-63.12 0-25.53 8.42-42.74 30.48-55.63 75.24-42.07 111.38-111.78 111.4-194.86 0.02-93.68-53.37-179.33-141.18-211.98-162.16-60.3-314.72 57.99-314.72 211.91 0 83.44 46.16 157.74 112.2 195.37 22.42 13.65 29.68 29.82 29.68 55.19 0 31.8-28.09 63.12-52.84 63.12H215.72c-54.32 0-98.36 44.04-98.36 98.36v99.57h789.29v-99.57c-0.01-54.32-44.04-98.36-98.37-98.36zM117.36 857.7h789.29V960H117.36z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol